const container = new WeakMap();

export default {

    set(self, name, val) {
        if (!container.has(self)) container.set(self, {});
        let map = container.get(self);
        return map[name] = val;
    },

    get(self, name) {
        if (container.has(self)) {
            let map = container.get(self);
            if (name in map) return map[name];
        }

        return undefined;
    },

    getAll(self) {
        if (container.has(self)) return container.get(self);
        else return {};
    },

    keys(self) {
        if (container.has(self)) return Object.keys(container.get(self));
        else return [];
    }
}